// Webpacker exposed a Node-style `process` global so legacy code can read
// `process.browser`, `process.env.NODE_ENV`, etc. Vite doesn't, so define a
// minimal browser-shaped one. Real env vars should use Vite's `import.meta.env`.
if (typeof globalThis.process === 'undefined') {
  globalThis.process = {
    browser: true,
    env: { NODE_ENV: import.meta.env.MODE || 'development' },
  };
}
